













import { Component, Mixins, Prop } from "vue-property-decorator";
import { IFreeInputableWrappedObject } from "../objects/IFreeInputableWrappedObject";
import { DisableableMixin } from "../../../system/mixins";
import ToggleFreeInputMethodSelector from "./ToggleFreeInputMethodSelector.vue";
import InputMethodEditCheckBox from "./InputMethodEditCheckBox.vue";

@Component({
  components: {
    ToggleFreeInputMethodSelector,
    InputMethodEditCheckBox,
  }
})
export default class ToggleFreeInputMethodEditor extends Mixins(DisableableMixin) {
  @Prop()
  source: IFreeInputableWrappedObject;

  get isFreeInputable(): boolean {
    return this.source.isFreeInputable;
  }

  get selected(): boolean {
    return this.source.shouldInputFree;
  }

  set selected(value: boolean) {
    this.source.shouldInputFree = value;
  }
}
